/* 🤖 this file was generated by svg-to-ts */
export const emperorIconPencilCircle2: {
  name: 'pencil_circle_2';
  data: string;
} = {
  name: 'pencil_circle_2',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0-.01h24v24H0Z"/><path d="M12 2C6.477 2 2 6.477 2 12c0 5.523 4.477 10 10 10s10-4.48 10-10c0-5.53-4.48-10-10-10ZM6.4 17.803l1.415-4.243 2.82 2.82 -4.243 1.41Zm10.6-7.78l-4.95 4.948 -2.83-2.83 4.94-4.95c.78-.79 2.04-.79 2.82 0 .78.78.78 2.04-.001 2.83Z"/></svg>`,
};
